export const servicioData = [
  {icon: 'far fa-check-circle', servicio: 'Peluqueria'},
  {icon: 'far fa-check-circle', servicio: 'Solarium'},
  {icon: 'far fa-check-circle', servicio: 'Manicura'},
  {icon: 'far fa-check-circle', servicio: 'Pedicura'},
  {icon: 'far fa-check-circle', servicio: 'Ceras'},
  {icon: 'far fa-check-circle', servicio: 'Tatuajes'},
];
